import { render, staticRenderFns } from "./collab_task_transfer.vue?vue&type=template&id=472dd523&scoped=true"
import script from "./collab_task_transfer.vue?vue&type=script&lang=js"
export * from "./collab_task_transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472dd523",
  null
  
)

export default component.exports